<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>School Notifications</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <send-notification v-if="pagepermission.insertable" @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center mb-2">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
            >
              <a-select-option v-for="schoolSession in schoolSessions" :key="schoolSession.id" :value="schoolSession.id">
                {{ schoolSession.name }}
                <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedClass"
              placeholder="All Classes"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleClassSelect"
              :filterOption="false"
            >
              <a-select-option :value="undefined">All Classes</a-select-option>
              <a-select-option v-for="schoolClass in schoolClasses" :key="schoolClass.id" :value="schoolClass.id">
                {{ schoolClass.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Section Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSection"
              placeholder="All Sections"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSectionChange"
              :filterOption="false"
              :disabled="!selectedClass"
            >
              <a-select-option :value="undefined">All Sections</a-select-option>
              <a-select-option v-for="section in sections" :key="section.id" :value="section.id">
                {{ section.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Student Search -->
          <div class="col-md-6 col-12 mb-2" v-if="!selectedRowKeys.length">
            <div class="text-right">
              <a-input-search
                placeholder="Search Notifications.."
                size="large"
                v-model="search"
                @search="searchNotifications"
                @change="searchNotifications"
              />
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <NeoNotifyTable :data="data" :rolesetting="pagepermission" :loading="loading" :session="selectedSession" @updateTable="handleUpdateTable" @selectChange="handleTableSelect"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          />
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import NeoNotifyTable from '@/components/notify/Table/index'
import SendNotification from '@/components/notify/Forms/index'
import { debounce, find } from 'lodash'

export default {
  components: {
    NeoNotifyTable,
    SendNotification,
  },
  beforeMount() {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('notification', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
        this.getSchoolNotifications()
      })
      .catch(error => {
        console.log(error)
      })
  },
  created() {
    this.searchNotifications = debounce(this.searchNotifications, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data() {
    return {
      loading: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      search: null,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getSchoolNotifications() {
      this.loading = true
      this.$http.get('/api/notifications/all', {
        params: {
          limit: this.pageSize,
          page: this.current,
          search: this.search,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchNotifications: function(e) {
      this.search = e.target.value
      this.getSchoolNotifications(true)
    },
    handleCreated() {
      this.current = 1
      this.getSchoolNotifications()
    },
    handleUpdateTable() {
      this.getSchoolNotifications()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getSchoolNotifications()
    },
    onChange(current) {
      this.current = current
      this.getSchoolNotifications()
    },
    handleSessionChange(value) {
      this.selectedSession = value
      this.selectedClass = undefined
      this.selectedSection = undefined
      this.getClasses()
      this.getSchoolNotifications()
    },
    handleClassSelect(value) {
      this.selectedClass = value
      this.selectedSection = undefined
      this.getSections()
      this.getSchoolNotifications()
    },
    handleSectionChange(value) {
      this.selectedSection = value
      this.getSchoolNotifications()
    },
    getClasses() {
      this.$http.get('/api/class', { params: { session_id: this.selectedSession } })
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
    },
    getSections() {
      if (!this.selectedClass) return
      this.$http.get(`/api/section/class/${this.selectedClass}`, { params: { session_id: this.selectedSession } })
        .then(({ data }) => {
          this.sections = data.data
        })
    },
  },
}
</script>
